import { Injectable } from '@angular/core';

export interface LocalLog {
  message: string;
  created: Date;
  level: string;
  source: string;
}

@Injectable({ providedIn: 'root' })
export class LogStorageService {
  // This service is used to store logs in local storage
  // a method to store logs in local storage
  storeLog(log: string, level: string, source: string): void {
    const logs = this.getLogs();
    // if logs are more than 20, remove the first one
    if (logs.length > 20) {
      logs.shift();
    }
    const tosave = {
      message: log,
      level: level,
      created: new Date(),
      source: source,
    } as LocalLog;
    logs.push(tosave);
    localStorage.setItem('logs', JSON.stringify(logs));
  }

  // a method to get logs from local storage
  getLogs(): LocalLog[] {
    const logs = localStorage.getItem('logs');
    return logs ? JSON.parse(logs) : [];
  }
}
